const NotFoundPage = () => {
    return (
        <div className="conteneur">
            <div className="texte">
                <h5 className="centered"><b>Erreur 404</b></h5>
                <span >La page demandée est introuvable ou n'existe pas.</span>
            </div>
        </div>
    );
};
export default NotFoundPage;